<template>
  <section>
    <h1>Your activities</h1>
    <div v-if="!hasActivities">
      <h2 v-if="!hasActivities">You haven't started tracking yet</h2>
      <AddActivity />
    </div>
    <div class="activitiesList" v-if="hasActivities">
        <div class="activitiesListSection activitiesListActive" v-bind:class="{ multi: hasInactiveActivities }">
          <h2>Active Activities</h2>
          <p v-if="!hasActiveActivities">
            No active activities - add one <span v-if="hasInactiveActivities">or select from Inactives</span>
          </p>
          <ul v-if="hasActiveActivities">
            <ActivityManage v-for="activity in activities"
              v-bind:key="activity.id"
              v-bind:id="activity.id"
              v-bind:activity="activity"
            ></ActivityManage>
          </ul>
          <AddActivity />
        </div>
        <div class="activitiesListSection activitiesListInactive" v-if="hasInactiveActivities">
          <h2>Inactive Activities</h2>
          <ul>
            <li v-for="activity in inactiveActivities" v-bind:key="activity.id">{{ activity.title }}
              <button class="subtleButton" @click="setActive(activity, true)">Set Active</button>
              <button class="subtleButton" @click="deleteActivity(activity)">Delete</button>
            </li>
          </ul>
        </div>
    </div>
  </section>
</template>

<script>
import AddActivity from '@/components/activities/AddActivity'
import ActivityManage from '@/components/activities/ActivityManage'
import {store} from '@/store'
import DataMain from '@/data/dataMain'
import DataActivities from '@/data/controllers/DataActivities'

export default {
  name: 'Activities',
  components: {
    'AddActivity': AddActivity,
    'ActivityManage': ActivityManage
  },
  data () {
    return {

    }
  },
  computed: {
    activities () {
      return store.state.activities.active
    },
    hasActivities () {
      /*
      if (!typeof(store.state.activities.active) === 'undefined' ) {
        return false;
      }
      */
      return Object.keys(store.state.activities.active).length > 0 || Object.keys(store.state.activities.inactive).length > 0
    },
    hasActiveActivities () {
      return Object.keys(store.state.activities.active).length > 0
    },
    activityCheck () {
      return store.state.activityCheck
    },
    hasInactiveActivities () {
      return Object.keys(store.state.activities.inactive).length > 0
    },
    inactiveActivities () {
      return store.state.activities.inactive
    }
  },
  created () {
    DataMain.getActivities()
  },
  methods: {
    setActive (activity, active) {
      DataActivities.setActive(activity.id, active)
    },
    deleteActivity (activity) {
      let c = confirm('This will delete all record of this activity forever - there is no going back. Are you sure?')
      if (c) {
        DataActivities.deleteActivity(activity.id)
      }
    },
    editActivity (activity) {
    }
  }

}
</script>

<style lang="scss">
  @import '../../scss/variables/variables';
  $flexBoxWidth: 400px;
  $flexBoxGap: 12.5px;
  $flexBoxPadding: 12.5px;
  $flexBoxMedia: $flexBoxWidth*2 + $flexBoxGap*3 + $flexBoxPadding*2 + 4;

  .activitiesList {
    display: block;

    .addActivity {
      margin-top: 40px;
      text-align: center;
    }
  }
  .activitiesListSection {
    flex: 0 1 $flexBoxWidth;
    padding: $flexBoxPadding;
    max-width: 600px;
    margin: auto;
    h2 {
      text-align: center;
    }
    ul {
      list-style-type: none;
      text-align: center;
      margin: 0;
      padding: 0;
      button {
        white-space: nowrap;
      }
    }
  }
  .activitiesListActive {
    flex: 0 1 $flexBoxWidth;
    background-color: $brandSalmon25;
    background-color: $brandBrightGreen25;
    border: 2px solid $brandBrightGreen;
    .addActivity {
      a {
        color: $brandSalmon;
        text-decoration: none;
        &:hover {
          text-decoration: underline;
        }
      }
      button, input {
        background: none;
        border-color: $brandSalmon;
        color: $brandSalmon;
      }
    }
    ul {
      max-width: $flexBoxWidth;
      margin: auto;
    }
    h2, ul, .addActivity {
      text-align: center;
    }
  }
  .activitiesListInactive {
    background-color: $brandLightGrey25;
    * {
      color: $brandDarkGray;
    }
  }

  @media (min-width: $flexBoxMedia) {
    .activitiesList {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      // column-gap: $flexBoxGap;
      > * {
        margin: 0 $flexBoxGap;
      }
    }
    .activitiesListSection {
      // margin: unset;
      h2, ul, .addActivity {
          text-align: left;
        }
      }
      .activitiesListActive.multi {
        flex: 0 1 $flexBoxWidth;
        ul {
          max-width: none;
        }
        h2, ul, .addActivity {
          text-align: right;
        }

      }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/Activities.vue